<template>
  <div>
    <v-text-field
      v-model="breadcrumb"
      :loading="loading"
      dense
      label="دسته بندی آگهی"
      outlined
      prepend-inner-icon="mdi-menu"
      @click="showCategories"
    />
    <custom-popup
      v-model="toggleCategory"
      :cons="{ title: 'انتخاب دسته بندی آگهی' }"
      max-width="500"
      reloadable
      @on-reload="reloadCategory"
    >
      <v-card flat :loading="loading" class="px-4">
        <!--<h5 style="font-size: 12pt" class="btn btn-block btn-grad text-center text-white">{{ this.pageName }}</h5>-->
        <p
          class="pt-3"
          v-if="this.breadcrumb.length === 0 && this.edit === false"
        >
          دسته آگهی مورد نظر خود را انتخاب کنید.
        </p>
        <a
          class="btn btn-link text-decoration-none text-dark"
          v-if="this.breadcrumb.length >= 1 && showCategory"
          @click="backCategory()"
        >
          <!-- v-if="this.breadcrumb.length != 0" @click="backCategory()"> -->
          <i class="fa fa-arrow-right text-dark mx-2"></i>
          بازگشت به دسته اصلی
        </a>

        <nav
          aria-label="breadcrumb"
          class="breads mx-5 mt-2"
          v-if="breadcrumb.length > 0"
          @click="loadCategory()"
        >
          <ol class="breadcrumb">
            <li
              class="breadcrumb-item mx-2"
              style="cursor: pointer"
              aria-current="page"
              v-for="(item, index) in breadcrumb"
              :key="index"
            >
              {{ item }}
            </li>
          </ol>
        </nav>

        <ul
          v-show="showCategory && this.edit === false"
          style="list-style: none"
          class="my-5 mx-5 px-3"
        >
          <input
            type="hidden"
            required
            name="category"
            id="category"
            :value="current"
            @change="getCurrent"
          />
          <v-list-item
            v-for="(item, i) in category.filter(
              (x) => x.parentSlug === current
            )"
            :key="i"
            @click="changeCategory(item)"
            tag="li"
            dense
            color="primary"
          >
            <v-list-item-icon class="me-3">
              <v-icon color="primary">mdi-{{ getCatIcon(item) }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
                class="primary--text"
                style="font-size: 1.2em; line-height: 1.5em"
              />
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-left</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-list-item
            @click="changeCategory(category.find((x) => x.slug === current))"
            v-if="breadcrumb.length >= 1"
          >
            <v-list-item-icon class="me-2"> </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title
                class="primary--text"
                style="font-size: 1.2em; line-height: 1.5em"
              >
                انتخاب کل زیر دسته های {{ breadcrumb[breadcrumb.length - 1] }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-left</v-icon>
            </v-list-item-action>
          </v-list-item>
          <!--                <li style="font-size: 11pt;" class="cursor-pointer py-2 ps-5"-->
          <!--                    v-for="(item, i) in category.filter((x) => x.parentSlug === current)" :key="i"-->
          <!--                    @click="changeCategory(item)">-->
          <!--                    <i v-for="(x, index) in catIcons.filter(y => y.slug === item.slug)" :key="index" :class="x.icon"-->
          <!--                       style="margin: 0 1rem;font-size: 14pt;color: #3F51B5"></i>-->
          <!--                    <i :class="'kt-icon kt-icon-' + item.slug + ' kt-icon&#45;&#45;lg kt-base-row__icon'"-->
          <!--                       v-if="item.parentSlug === 'root'"></i>-->
          <!--                    {{ item.title }}-->
          <!--                    <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>-->
          <!--                </li>-->
          <!--                <li @click="changeCategory(category.find((x) => x.slug === current))" style="font-size: 11pt;"-->
          <!--                    class="cursor-pointer py-2 ps-5" v-if="breadcrumb.length >=1">-->
          <!--                    انتخاب کل زیر دسته های {{ breadcrumb[breadcrumb.length - 1] }}-->
          <!--                    <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>-->
          <!--                </li>-->
        </ul>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import { Bus } from "@/main";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import axios from "axios";

export default {
  name: "categoryselector",

  components: { CustomPopup },

  props: {
    auto_changes: {
      default: false,
      require: true,
    },
    phone: {
      default: undefined,
    },
    multiAdsCat: {
      type: Boolean,
      default: true,
    },
    pageName: {
      type: String,
      default: "ثبت آگهی",
    },
    edit: {
      type: Boolean,
      default: false,
    },
    edit_def: {
      type: Boolean,
      default: false,
    },
    editCategory: {
      type: String,
      default: "root",
    },
    gradual: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    isExpert: false,
  },

  data() {
    return {
      before: [],
      breadcrumb: [],
      showCategory: true,
      toggleCategory: false,
      queryString: new URLSearchParams(),
      current: "root",
      Rp: [],
      loading: false,
      loadSelect: false,
      timer: null,
      cityReq: "",
      category: [],
      Rp: [],
      timer: null,
      singleFiltered: {
        contact: null,
        zoonkan_enabled: null,
        category: null,
        secure_call_more_info: null,
        location: null,
        optional_fields_description_section: null,
        other_options_and_attributes: null,
        call_method: null,
        images: null,
        hide_phone: null,
        chat_enabled: null,
        phone: null,
        force_chat_enabled: null,
      },
      multiFiltered: {
        force_chat_enabled: null,
        title: null,
        secure_call_more_info: null,
        description: null,
        hide_phone: null,
        chat_enabled: null,
        phone: null,
        new_price: null,
        contact: null,
        zoonkan_enabled: null,
        category: null,
        location: null,
        optional_fields_description_section: null,
        images: null,
        other_options_and_attributes: null,
        colored_parts: null,
      },
      catIcons: [
        { icon: "fa fa-home", slug: "real-estate" },
        { icon: "fa fa-car", slug: "vehicles" },
        { icon: "fa fa-desktop", slug: "electronic-devices" },
        { icon: "fa fa-lightbulb", slug: "home-kitchen" },
        { icon: "fa fa-wrench", slug: "services" },
        { icon: "fa fa-user", slug: "personal" },
        { icon: "fa fa-dice", slug: "leisure-hobbies" },
        { icon: "fa fa-users", slug: "community" },
        { icon: "fa fa-industry", slug: "tools-materials-equipment" },
        { icon: "fa fa-briefcase", slug: "jobs" },
      ],
      forNational: [],
    };
  },

  beforeMount() {
    this.getCategories();
  },

  mounted() {
    if (this.isExpert) this.current = "services";
    Bus.$on("cityInfo", (value) => {
      this.cityReq = value.city;
    });

    Bus.$on("selected_numbers", (value) => {
      this.phone = value;
    });

    Bus.$on("getBreadCrumb", () => {
      this.before = [];
      this.breadcrumb = [];
      this.findSource(this.editCategory);
    });
    Bus.$on("cityInfo", (value) => {
      this.cityReq = value.city;
    });

    this.getCategories();
    Bus.$on("reload", (fields) => {
      this.fields = fields;
    });

    Bus.$on("getBreadCrumb", () => {
      this.before = [];
      this.breadcrumb = [];
      this.findSource(this.editCategory);
    });
  },

  computed: {
    categoryRenderer() {
      return this.category.filter((x) => x.parentSlug === this.current);
    },
  },

  watch: {
    breadcrumb(newVal) {
      // alert(newVal.toString())
      this.$emit("getBreadcrumb", newVal.toString());
    },
    fields: function () {
      this.$emit("category-fields", this.fields);
      this.Buses();
    },
    current: {
      handler: function (value) {
        this.debounce(() => {
          Bus.setProp("category_current", value);
          Bus.$emit("category-current", value);
        }, 4000);
      },
      deep: true,
    },
    auto_changes: function (value) {
      if (value === true) {
        this.getFields(this.current);
        this.debounce(function () {
          Bus.$emit("category-current", this.current);
        }, 500);
      } else return false;
    },
    cityReq: function () {
      const vue = this;
      if (vue.current !== "root") {
        const mine = $.ajax({
          url:
            `${url}/divar/categories/${this.current}/dependency` +
            vue.queryString.toString(),
          type: "POST",
          dataType: "json",
          fn: this.mine,
          headers: {
            Authorization: Token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            contact: {
              phone: this.phone || undefined,
            },
            location: {
              city: this.cityReq,
            },
            category: this.current,
            images: [],
          }),
          success: function (data) {
            if (vue.multiAdsCat)
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.multiFiltered).includes(x.name)) {
                  vue.multiFiltered[x.name] = true;
                  return false;
                }
                return true;
              });
            else
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.singleFiltered).includes(x.name)) {
                  vue.singleFiltered[x.name] = true;
                  return false;
                }
                return true;
              });
            vue.forNational = vue.fields;
            Bus.setProp("category_fields", vue.fields);
          },
        });
      }
    },
    forNational: function (value) {
      Bus.$emit("national", !!value.find((x) => x.name === "national_id"));
    },
    phone(val) {
      const vue = this;
      if (vue.current !== "root") {
        const mine = $.ajax({
          url:
            `${url}/divar/categories/${this.current}/dependency` +
            vue.queryString.toString(),
          type: "POST",
          dataType: "json",
          fn: this.mine,
          headers: {
            Authorization: Token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            contact: {
              phone: this.phone || undefined,
            },
            location: {
              city: this.cityReq,
            },
            category: this.current,
            images: [],
          }),
          success: function (data) {
            if (vue.multiAdsCat)
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.multiFiltered).includes(x.name)) {
                  vue.multiFiltered[x.name] = true;
                  return false;
                }
                return true;
              });
            else
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.singleFiltered).includes(x.name)) {
                  vue.singleFiltered[x.name] = true;
                  return false;
                }
                return true;
              });
            vue.forNational = vue.fields;
            Bus.setProp("category_fields", vue.fields);
          },
        });
      }
    },
  },

  methods: {
    requestApiGet(uri, queries = {}, serializer = null) {
      return axios.get(`${this.$robotApi}/divar/${uri}`, {
        headers: this.header(),
        params: queries,
        paramsSerializer: serializer,
      });
    },
    header() {
      return {
        Authorization: Token ? `Bearer ${Token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },

    getCatIcon(cat) {
      return this.catIcons.filter((item) => item.slug === cat.slug)[0]?.icon;
    },
    findSource(currentSlug) {
      if (currentSlug === "root") {
        this.before.push("root");
        this.breadcrumb.reverse();
        this.before.reverse();
        this.before.pop();
        this.current = this.editCategory;
        this.getFields(this.editCategory);
        return "root";
      }
      if (this.edit || this.edit_def) {
        const result = this.category.find((x) => x.slug === currentSlug);
        this.breadcrumb.push(result.title);
        this.before.push(result.slug);
        return this.findSource(result.parentSlug);
      }
    },
    loadCategory() {
      if (this.$data.showCategory) return;

      this.$data.showCategory = true;
      this.$data.current = this.$data.before.pop();
      this.$data.breadcrumb.pop();
    },
    backCategory: function () {
      if (this.before.length <= 0) return;

      this.current = this.before.pop();
      this.breadcrumb.pop();
    },
    changeCategory: function (item) {
      let search = this.category.filter((x) => x.parentSlug === item.slug);

      if (search.length === 0 || this.current === item.slug) {
        this.showCategory = false;
        this.getFields(item.slug);
      }

      this.before.push(this.current);
      this.current = item.slug.toString();
      this.breadcrumb.push(item.title);
    },
    getFields: function (slug, breadcrumb = true) {
      const vue = this;

      vue.loadSelect = true;
      this.$data.showCategory = false;

      if (breadcrumb)
        $.ajax({
          url:
            `${url}/divar/categories/${slug}/dependency` +
            vue.queryString.toString(),
          type: "POST",
          dataType: "json",
          fn: this.getFields,
          data: {
            contact: {
              phone: this.phone || undefined,
            },
            location: {
              city: this.cityReq,
            },
            category: this.current,
            images: [],
          },
          headers: {
            Authorization: Token,
            Accept: "application/json",
          },
          success: function (data) {
            vue.loadSelect = false;
            if (vue.multiAdsCat)
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.multiFiltered).includes(x.name)) {
                  vue.multiFiltered[x.name] = true;
                  return false;
                }
                return true;
              });
            else
              vue.fields = data.data.filter((x) => {
                if (Object.keys(vue.singleFiltered).includes(x.name)) {
                  vue.singleFiltered[x.name] = true;
                  return false;
                }
                return true;
              });

            Bus.setProp("category_fields", vue.fields);
          },
          error: function () {
            vue.loadSelect = false;
          },
        });
    },
    generateQueryString(key, value) {
      this.queryString.delete(key);
      this.queryString.append(key, value);
      this.getFields(this.current, false);
    },
    getCategories() {
      const vue = this;
      vue.loading = true;
      $.ajax({
        url: `${url}/divar/categories`,
        type: "GET",
        fn: this.getCategories,
        dataType: "json",
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: function (data) {
          vue.category = data.data;
          vue.loading = false;
        },
        error: function () {
          vue.loading = false;
        },
      });
    },
    Buses() {
      Bus.$emit("category-multi-filtered", this.multiFiltered);
      Bus.$emit("category-single-filtered", this.singleFiltered);
    },
    debounce(fn, timout = 1000) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, timout);
    },
    getCurrent() {
      if (this.gradual === true) {
        this.getFields(this.current);
        this.debounce(function () {
          Bus.$emit("category-current", this.current);
        }, 500);
      } else return false;
    },
    showCategories() {
      this.toggleCategory = true;
    },
    reloadCategory() {
      this.current = "root";
      this.showCategory = true;
      this.fields = [];
      this.before = [];
      this.breadcrumb = [];
      Bus.$emit("category-current", "root");
    },
  },
};
</script>

<style scoped>
.btn-grad {
  background-image: linear-gradient(
    to right,
    #000046 0%,
    #1cb5e0 51%,
    #000046 100%
  );
  text-align: center;
  text-transform: uppercase;
  transition: 0.7s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
}

.btn-grad:hover {
  background-position: right center;
  /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
  transition: 0.7s;
}
</style>
